module.exports = __webpack_public_path__ + "img/ANTARGAZ.2dc30f67.png";